import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldEditorMapViewSelectorComponent } from './field-editor-map-view-selector.component';
import {DxButtonGroupModule, DxToolbarModule} from 'devextreme-angular';



@NgModule({
  declarations: [FieldEditorMapViewSelectorComponent],
  imports: [
    CommonModule,
    DxToolbarModule,
    DxButtonGroupModule
  ],
  exports: [FieldEditorMapViewSelectorComponent]
})
export class FieldEditorMapViewSelectorModule { }
